// prettier-ignore
export const config = {
    BACKEND_URL: process.env.REACT_APP_BACKEND_URL!,
    GOOGLE_CLIENT_ID: process.env.REACT_APP_GOOGLE_CLIENT_ID!,
    APPLE_CLIENT_ID:  process.env.REACT_APP_APPLE_CLIENT_ID!,
    APPLE_REDIRECT_URL:  process.env.REACT_APP_APPLE_REDIRECT_URL!,
    FACEBOOK_ID: process.env.REACT_APP_FACEBOOK_ID!,
  }
